import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import { PageLoading } from '@/components';
import { initReactQueryAuth } from '@/libs/auth';
import { login, me, register } from '@/pages/login/api';
import storage from '@/utils/storage';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { LoginPath } from '@/config';

async function loadUser() {
  // 判断是否可以发送请求
  if (storage.getToken()) {
    const data = await me();
    return data.data;
  }

  return null;
}

async function loginFn(data) {
  const response = await login(data);
  storage.setToken(response.data.token);
  const meRes = await me();
  return meRes.data;
}

async function registerFn(data) {
  const response = await register(data);
  return response.data;
}

async function logoutFn() {
  _Message.info({
    content: '修改成功，请重新登录',
    duration: 1000,
    onClose: () => {
      storage.clearToken();
      window.location.href = LoginPath;
    }
  });
}

const authConfig = {
  loadUser,
  loginFn,
  logoutFn,
  registerFn,

  LoaderComponent() {
    return /*#__PURE__*/React.createElement(PageLoading, null);
  }

};
export const {
  AuthProvider,
  useAuth
} = initReactQueryAuth(authConfig);
// guest:true , authGuard:false => only guest entry
// guest:false, authGuard:true => only auth entry
// guest:false, authGuard:false => no check
export function Guard({
  children,
  authGuard,
  guestGuard
}) {
  const auth = useAuth(); // const location = useLocation();
  // only guest

  if (guestGuard && auth.user) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/",
      replace: true
    });
  } // only auth


  if (authGuard && !auth.user) {
    window.location.href = 'https://google.com'; // return <Navigate to={LoginPath} state={{ from: location }} replace />;

    return null;
  }

  return children;
}